import React from 'react';
import { ButtonWrapper, TabButtonContainer } from './TabButton.styles';
import Badge from '../Badge/Badge';
import Stack from 'src/app/atoms/Layout/Stack/Stack';

export interface TabButtonProps {
  label: string;
  onClick: (tabLabel: string) => void;
  isSelected: boolean;
  badge?: string;
}

const TabButton = ({ label, onClick, isSelected, badge }: TabButtonProps): JSX.Element => {
  return (
    <TabButtonContainer $isSelected={isSelected}>
      <ButtonWrapper
        className='tab-button'
        size='sm'
        variant='secondary'
        onClick={() => onClick(label)}
        icon={
          badge && (
            <Stack marginLeft='spacing-md'>
              <Badge
                label={badge}
                color='gray'
                padding={['spacing-xxs', 'spacing-sm']}
              />
            </Stack>
          )
        }
        iconPosition='right'
      >
        {label}
      </ButtonWrapper>
    </TabButtonContainer>
  );
};
export default TabButton;
